import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";
import { Countries } from "../../Constant";

export const MyCountrySelect = (props) => {
  const { t } = useTranslation();

  const getLocalizedLabel = (option) => {
    const translationKey = `countries.${option.code}`;
    const translated = t(translationKey);
    // If translation exists and is not the key itself, use it; otherwise fallback to English label
    return translated !== translationKey ? translated : option.label;
  };

  return (
    <Autocomplete
      style={{ width: "100%", margin: "1rem 0", ...props.style }}
      className={props.className}
      id={props.id ?? "country-select"}
      options={Countries}
      value={props.value}
      autoHighlight
      onChange={props.onChange}
      noOptionsText={props.noOptionsText ?? "Inga alternativ"}
      disableClearable={true}
      getOptionLabel={(option) => `${getLocalizedLabel(option)} +${option.phone}`}
      fullWidth={true}
      renderOption={(props, option) => {
        const { key, ...optionProps } = props;
        return (
          <Box key={`${option.label}-${option.code}`} component="li" {...optionProps}>
            {`${getLocalizedLabel(option)} +${option.phone}`}
          </Box>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={props.label}
          slotProps={{
            htmlInput: {
              ...params.inputProps,
              autoComplete: "off", // disable autocomplete and autofill
            },
          }}
        />
      )}
    />
  );
};
